import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardLink } from './UiCard.styles';
import { isBackgroundFieldArray } from '../../styles';
import { LinkButton, useAnalytics } from '../..';
export default function UiCard({ model }) {
    const { entryTitle, title, content, decoration, linkText, linkAppearance, route } = model.content;
    const { sendTrackEvent } = useAnalytics();
    return linkText ? (_jsxs(Card, Object.assign({ decoration: isBackgroundFieldArray(decoration) ? decoration : undefined, appearance: linkAppearance }, { children: [_jsx("h3", { children: title }, void 0), _jsx("p", { children: content }, void 0), route.content && (_jsx(LinkButton, Object.assign({ url: route.content.path, appearance: linkAppearance, prominence: "Reduced", isBlock: true, onClick: () => sendTrackEvent('clickedUiCard', {
                    event: 'clicked',
                    eventComponent: 'CTA',
                    eventContainer: model.type,
                    label: `${title}_${linkText}`,
                    labelEnglish: entryTitle,
                    uuid: model.id,
                    href: route.content.path,
                    theme: linkAppearance
                }), testId: "cta" }, { children: linkText }), void 0))] }), void 0)) : route.content ? (_jsxs(CardLink, Object.assign({ decoration: isBackgroundFieldArray(decoration) ? decoration : undefined, href: route.content.path, onClick: () => sendTrackEvent('clickedUiCard', {
            event: 'clicked',
            eventComponent: model.type,
            eventContainer: 'content',
            label: title,
            labelEnglish: entryTitle,
            uuid: model.id,
            href: route.content.path
        }), "data-testid": "card-link" }, { children: [_jsx("h3", { children: title }, void 0), _jsx("p", { children: content }, void 0)] }), void 0)) : null;
}
//# sourceMappingURL=UiCard.js.map